import { render, staticRenderFns } from "./SectionParagraph.vue?vue&type=template&id=5521ddd4"
import script from "./SectionParagraph.vue?vue&type=script&lang=js"
export * from "./SectionParagraph.vue?vue&type=script&lang=js"
import style0 from "./SectionParagraph.vue?vue&type=style&index=0&id=5521ddd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports